//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { usePreviewOrder, useOCart, useUser, useApiError, useOrderCreate, useCredential, useOrderPaymethod, usePay } from '@bee-hole/coms';
import { usePreOrderStore } from '~/stores/newPreOrder';
import { useOrder } from '~/composables';
import { computed, useRoute, onMounted, onBeforeUnmount, ref, useRouter } from '@nuxtjs/composition-api';
import { onSSR } from "@vue-storefront/core";
import { EventBus } from '@/plugins/eventBus';
import newCartPreview from '~/components/Checkout/newCartPreview.vue';
import ShippingAddressSelect from '~/components/MyAccount/ShippingAddressSelect';
import { useUiState, useUiNotification } from '~/composables';
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import shippingSelect from '~/components/Checkout/shippingSelect.vue';
import IdCard from '~/components/Checkout/IdCard';
extend('required', {
  ...required,
  message: 'Shipping_valid_required'
});
import {
  SfHeading,
  SfInput,
  SfButton,
  SfSelect,
  SfLink,
  SfAddressPicker,
  SfModal,
  SfCharacteristic,
  SfCheckbox,
  SfImage,
  SfProperty,
  SfAccordion,
  SfList,
  SfTextarea,
  SfQuantitySelector,
  SfCircleIcon,
  SfDivider,
  SfIcon,
  SfRadio
} from '@storefront-ui/vue';
import shippingForm from '~/components/Checkout/shippingForm.vue';
import confirmModal from '~/components/ContentModal/confirm';
export default {
  name: 'Checkouts',
  layout() {
    return 'checkoutPay';
  },
  setup(props, context) {
    const { preorder, preview, error: preOrderErr, loading: preOrderLoading } = usePreviewOrder();
    const preOrderStore = usePreOrderStore();
    const { loading, cart, load: loadCart, clear: clearCart } = useOCart();
    const { user, load: loadUser } = useUser();
    const { set: setError } = useApiError();
    const { create, result: orderRes } = useOrderCreate();
    const { getPinJu, result: pingju } = useCredential();
    const { isMobile, resize } = useUiState();
    //
    const { load: loadOrder, isPayed } = useOrder(user.value?.memberId + 'checkouts');
    //
    const { result: payResult, pay, loading: payLoding, error: payErr } = usePay();
    // components
    const addressForm = ref(null);
    const billingForm = ref(null);
    const payWayId = ref();
    const currency = ref();
    const IdCardRef = ref();
    // wei xin pay code
    const wechatPayCodeModal = ref();
    const wechatPayCodeImg = ref();
    const payCodeVisable = ref(true);
    const payTimer = ref(null);
    const timer = ref(null);
    // 支付吗
    const notify = useUiNotification();
    let Id = null;
    // form
    const observers = ref();
    // route
    const route = useRoute();
    const router = useRouter();
    // 收货地址id 与 账单地址id
    const addressIdRef = ref();
    const billingIdRef = ref();
    // 支付方式
    const { load: loadPayMethod, paymethod } = useOrderPaymethod();
    // 预下单信息
    const address = computed(() => preOrderStore.address);
    const builing = computed(() => preOrderStore.builing);
    const previewId = computed(() => preOrderStore.preview_id);
    const hasInsurance = computed(() => preOrderStore.hasInsurance);
    const billingAndShipping = ref(true);
    const orderNote = ref(preOrderStore.orderNote || '');
    const email = ref(preOrderStore.email || '');
    const createLodding = ref(false);
    const billingAddressChange = () => {
      preOrderStore.changeBillingAndShipping(billingAndShipping.value);
    };
    const isShowEmail = computed(() => user.value?.email.indexOf("@guest.com") !== -1);
    const timeoutId = ref(null);
    // goXpay
    const goXpay = () => {
      if (orderRes?.value?.prepay_id) {
        const transformedPath = `/xpay?orderNumber=${orderRes?.value?.prepay_id}&credential_id=${pingju.value?.credential_id}`;
        const localeTransformedPath = context?.root.localePath(transformedPath);
        router.push(localeTransformedPath);
      }
    };

    // 支付列表
    const payMethods = computed(() => {
      if (paymethod?.value?.list) {
        const array = JSON.parse(JSON.stringify(paymethod?.value?.list));
        const mallXianxiaPay = context?.root?.$options?.$mallConfig.mall_xianxia_pay;
        console.log('mallXianxiaPay', mallXianxiaPay)
        if (mallXianxiaPay && mallXianxiaPay.content && (((!mallXianxiaPay.trading_countries) || (mallXianxiaPay.trading_countries && mallXianxiaPay.trading_countries.length === 0)) || (mallXianxiaPay.trading_countries && mallXianxiaPay.trading_countries.length && preOrderStore.address && preOrderStore.address.country && mallXianxiaPay.trading_countries.indexOf(preOrderStore.address.country) !== -1))) {
          array.push({
            cnName: '',
            enName: '',
            currencies: [(mallXianxiaPay.content)],
            payWayId: '-999'
          });
        }
        return array;
      }
    });
    // 支付成功
    const goThankYou = (is_manual_payment) => {
      const transformedPath = { name: 'thank-you', query: { orderNumber: orderRes?.value?.prepay_id } };
      if (is_manual_payment) {
        transformedPath.query.is_manual_payment = 1;
      }
      context?.root.$router.push(context?.root.localePath(transformedPath));
    };
    // 查询订单状态
    const checkOrder = async () => {
      const time = 2000;
      timer.value = setInterval(async () => {
        await loadOrder(orderRes?.value?.prepay_id);
        // isLoading.value = false;
        if (isPayed.value) {
          clearInterval(timer.value);
          // console.log('=======支付成功');
          preOrderStore.clearIdCard();
          goThankYou();
        } else {
          // console.log('=======未支付');
        }
      }, time);
    };
    // 购物车商品
    const shoppingList = (() => {
      const list = [];
      cart?.value?.list?.map((item) => {
        const sku = {
          sku_id: item.skuId,
          num: item.num,
          sku_prop: item.properties,
          activity_id: ''
        };
        if (preOrderStore.services && preOrderStore.services?.[item.skuId]) {
          sku.service_ids = preOrderStore.services[item.skuId];
        }
        list.push(sku);
      });
      return list;
    });
    const initShouHuo = () => {
      // console.log('preOrderStore.shippingMethods', JSON.parse(JSON.stringify(preOrderStore.shippingMethods)), (!preOrderStore.shippingMethods || preOrderStore.shippingMethods?.length === 0));
      if (!preOrderStore.shippingMethods || preOrderStore.shippingMethods?.length === 0) {
        // console.log('preorder?.value?.orders', preorder?.value);
        preorder?.value?.orders.map((order) => {
          if (order?.express?.carryId && order?.shop?.shopId) {
            preOrderStore.setShippingMethod({
              carry_id: order.express.carryId,
              shop_id: order.shop.shopId
            });
            EventBus.$emit('changeExpress', order.express);
          }
        });
      }
    };
    // 预下单
    const preOrderAdd = async (addressId, billingId) => {
      // console.log('preOrderAdd ---------start');
      // if (!address?.value?.addressId) {
      //   console.log('---------------没有address');
      //   return;
      // }
      if (loading?.value) {
        return;
      }
      preOrderStore.initPreviewKey();
      const userKey = context?.root?.$cookies.get("userKey");
      const tokenkey = context?.root?.$cookies.get("tokenkey");
      const data = {
        address_id: addressId,
        fx_id: '0',
        from_id: tokenkey,
        // member_note: orderNote.value,
        shopping_list: shoppingList(),
        combine_pay: true,
        billing_address_id: billingId,
        has_insurance: hasInsurance.value,
        email: email.value
      };
      if (userKey) {
        data.user_id = userKey;
      }
      if (preOrderStore?.previewKey) {
        data.preview_serial_id = preOrderStore?.previewKey;
      }
      if (preOrderStore.shippingMethods && preorder.value && preOrderStore.shippingMethods.length === preorder.value?.orders?.length) {
        data.express = preOrderStore.shippingMethods;
      }
      if (previewId?.value) {
        data.preview_id = previewId?.value;
      }
      if (preOrderStore?.IdCard && preOrderStore?.IdCard?.id_number && preOrderStore?.IdCard?.id_name) {
        data.id_name = preOrderStore.IdCard.id_name;
        data.id_number = preOrderStore.IdCard.id_number;
        data.id_type = preOrderStore.IdCard.id_type;
      } else if (preorder?.value?.hasIdentityCheck && (preOrderStore?.IdCard?.id_type || preOrderStore?.IdCard?.id_number || preOrderStore?.IdCard?.id_name)) {
        // return false;
      }
      if (!preorder?.value?.expressChart || preorder?.value?.expressChart?.length === 0) {
        preOrderStore.clearShippingMethods();
      }
      if (preOrderStore?.address?.country) {
        data.delivery_country = preOrderStore?.address?.country;
      }
      if (preOrderStore?.address?.state) {
        data.delivery_state = preOrderStore?.address?.state;
      }
      await preview(data);
      initShouHuo();
      preOrderStore.setPreview_id(preorder?.value?.previewId);
      return preorder.value;
    };
    onBeforeUnmount(() => {
      // console.log('----------------卸载 checkout--------------');
      EventBus.$off('NewPreviewOrder');
      EventBus.$off('notification-shown');
      clearInterval(timer.value);
      clearInterval(payTimer.value);
      preOrderStore.setisAutoPromoCodePush(false);
      notify.allDismiss();
      if (process.client) {
        // 清除 resize 事件处理器
        window.onresize = null;
        if (timeoutId.value !== null) {
          // 清理定时器
          clearTimeout(timeoutId.value);
        }
      }
    });
    onSSR(async () => {
      await loadUser();
      await loadCart();
      await preOrderAdd();
      await loadPayMethod({});
    });
    onMounted(async () => {
      if (paymethod.value?.list) {
        payWayId.value = paymethod.value?.list[0]?.payWayId;
        currency.value = paymethod.value?.list[0]?.currencies?.[0];
        preOrderStore.setPaymethod(paymethod.value?.list[0]);
      }
      preOrderStore.clearpreviewId();
      if (process.client) {
        clearInterval(timer.value);
        window.onresize = resize;
        timeoutId.value = setTimeout(() => {
          resize();
        }, 100);
        EventBus.$on('notification-shown', (id) => {
          Id = id;
        });
        EventBus.$on('paycode-close-notification', (id) => {
          if (id) {
            // console.log('关闭通知');
            goXpay();
          }
          // 关闭通知
        });
        setTimeout(() => {
          observers.value.validate();
          // wechatPayCodeModal.value.setModal({
          //   title: context?.root.$t('removeCartItem'),
          //   showFooter: false
          // });
          // wechatPayCodeImg.value = 'https://img0.baidu.com/it/u=478486475,1265140082&fm=253&fmt=auto&app=138&f=JPEG?w=500&h=500';
          // notify.send({
          //   type: 'danger',
          //   image: wechatPayCodeImg.value,
          //   // persistent: true,
          //   icon: '',
          //   persist: true,
          //   time: 6000 || 0,
          //   class: 'notificationImage hideClose',
          //   action: {}
          // });
          wechatPayCodeImg.value = '';
        });
      }
      EventBus.$on('NewPreviewOrder', async (data) => {
        const addressId = addressIdRef.value && addressIdRef.value !== '-1' ? addressIdRef.value : null;
        const billingId = billingIdRef.value && billingIdRef.value !== '-1' ? billingIdRef.value : null;
        if (data.addressId) {
          if (data && data.country && data.state) {
            await preOrderAdd(addressId, billingId);
            await loadPayMethod({});
          }
        } else {
          await preOrderAdd(addressId, billingId);
        }
        // await loadPayMethod({});
      });
      // if (route.value.path.indexOf('/checkout') !== -1 && route.value.path !== '/checkout/shipping') {
      //   const currency = context.root.$cookies.get(VSF_CURRENCY_COOKIE);
      //   if (preOrderStore.currency && preOrderStore.currency !== currency) {
      //     // router.push(context.root.localePath('/checkout/shipping'));
      //   }
      // }
    });
    // 绑定邮箱
    const OrderEmailChange = (e) => {
      email.value = e.target.value;
      preOrderStore.setOrderEmail(email.value);
      // EventBus.$emit('NewPreviewOrder', email.value);
    };
    // 订单备注
    const OrderNoteChange = (e) => {
      orderNote.value = e.target.value;
      preOrderStore.setOrderNote(orderNote.value);
      // EventBus.$emit('NewPreviewOrder', orderNote.value);
    };
    // 验证邮箱
    const validateEmail = (email) => {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    };
    // 支付回调
    let baseUrl = '';
    if (process.client) {
      baseUrl = window.location.origin;
    }
    const backUrl = computed(() => {
      return baseUrl + context?.root?.localePath(`/checkout/thank-you?orderNumber=${orderRes?.value?.prepay_id}`);
    });
    const cancelUrl = computed(() => {
      return baseUrl + context?.root?.localePath(`/xpay?orderNumber=${orderRes?.value?.prepay_id}&credential_id=${pingju.value?.credential_id}`);
    });
    // 支付订单
    const payOrder = async () => {
      // await loadOrder();
      // if (isPayed.value) {
      //   // goThankYou();
      //   return;
      // }
      if (String(payWayId.value) === '-999') {
        goThankYou(true);
        // celarTime();
        // const transformedPath = `/my-account/History` + '?open=2&pid=' + orderNumber.value;
        // const localeTransformedPath = root.localePath(transformedPath);
        // root.$router.push(localeTransformedPath);
        return false;
      }
      // isLoading.value = true;
      let type = 'NATIVE';
      if (process.client) {
        type = /MicroMessenger/i.test(window.navigator.userAgent) ? 'JSAPI' : 'NATIVE';
        if (type === 'JSAPI') {
          if (!isMobile.value) {
            type = 'NATIVE';
          }
        }
        if (preOrderStore?.paymethod?.enName === 'Alipay' || preOrderStore?.paymethod?.enName === 'USEEPAY') {
          if (isMobile.value) {
            type = 'JSAPI';
          } else {
            type = 'H5';
          }
        }
      }
      const query = {
        scene_type: type,
        prepay_id: orderRes?.value?.prepay_id,
        scene_info: {
          paid_return_url: (backUrl.value),
          cancel_return_url: (cancelUrl.value)
        },
        combine_pay: true,
        currency: currency.value,
        pay_way_id: payWayId.value,
        credential_id: pingju.value?.credential_id
      };
      if (preOrderStore?.order?.combined === 2) {
        query.combine_pay = true;
      }
      // console.log('支付下单入参:', query);
      // setError('支付下单入参:' + query);
      // 判断backUrl是否http开头
      if (backUrl.value.indexOf('http') === 0) {
        await pay(query);
        // console.info('准备支付:', query);
      } else {
        setError({ message: '支付回调地址不合法:' + backUrl.value, code: 50 });
        return false;
      }
      const url64 = payResult.value?.jsapi?.auth_link;
      const h5Url = payResult.value?.h5?.h5_url;
      // console.log('payResult.value', payResult.value);
      if (url64) {
        // 对url进行base64解码
        const url = Buffer.from(url64, 'base64').toString('binary');
        window.location.href = url;
      }
      if (h5Url) {
        window.location.href = h5Url;
      }
      if (payErr.value) {
        setTimeout(() => {
          goXpay();
        }, 2000);
      }
      if (payResult?.value?.native?.qr_code_summary) {
        notify.allDismiss();
        // 等带200毫秒在执行
        await new Promise((resolve) => {
          setTimeout(() => {
            resolve();
          }, 500);
        });
        const wechatPayCode = 'data:image/jpeg;base64, ' + payResult?.value?.native?.qr_code_summary;
        wechatPayCodeImg.value = wechatPayCode;
        wechatPayCodeModal.value.setModal({
          title: context?.root.$t('wechatPayScannerCode'),
          showFooter: false
        });
        // notify.send({
        //   type: 'info',
        //   image: wechatPayCodeImg.value,
        //   // persistent: true,
        //   paycode: true,
        //   icon: '',
        //   persist: true,
        //   time: 600000 || 0,
        //   class: 'notificationImage centerImage',
        //   action: {
        //     text: context.root.$t('pay_code_refresh'),
        //     onClick: backProvider
        //   }
        // });
        checkOrder();
      }
      return payResult.value;
      // isLoading.value = false;
    };
    // 刷新支付吗
    const backProvider = () => {
      // payWayId.value = previewOrderStore?.paymethod?.payWayId;
      // js判断pc端每分钟执行一次
      console.log('刷新支付吗');
      clearInterval(payTimer.value);
      if (process.client) {
        payOrder();
        payCodeVisable.value = true;
        if (!/MicroMessenger/i.test(window.navigator.userAgent)) {
          payTimer.value = setInterval(async () => {
            payCodeVisable.value = false;
          }, 1800 * 1000);
        }
      }
    };
    const googleBeginChckout = ()=>{
      context.root.$gtm.push({
        event: "begin_payment",
        ecommerce: null
      });
      const googleItem = {
        event: "begin_payment",
        ecommerce: {
          currency: context?.root?.$cookies?.get('vsf-currency'),
          value: preorder.value?.payment,
          items: [
          ]
        }
      };
      preorder.value?.orders?.map((order)=>{
        order?.orderItem?.map((product)=>{
          googleItem.ecommerce.items.push({
            item_id: product.goodId,
            item_name: product.title,
            discount: product.discount,
            item_variant: product.skuProp,
            price: product.price,
            quantity: product.num
          });
        });
      });
      context.root.$gtm.push(googleItem);
    };
    // 创建订单成功
    const createSuccess = async () => {
      try {
        if (orderRes?.value?.prepay_id) {
          await getPinJu({ prepay_id: orderRes?.value?.prepay_id });
          if (email.value) {
            await loadUser();
          }
          if (pingju.value?.credential_id) {
            googleBeginChckout();
            // const transformedPath = `/xpay?orderNumber=${orderRes?.value?.prepay_id}&credential_id=${pingju.value?.credential_id}`;
            preOrderStore.ClearPreviewOrderInfo();
            // await clearCart();
            // await loadCart();
            const payRes = await payOrder();
            return payRes;
            // router.push(context.root.localePath(transformedPath));
          } else {
            createLodding.value = false;
          }
        } else {
          createLodding.value = false;
        }
      } catch (e) {
        console.log(e);
        return e;
      }
    };
    // 下单
    const processOrder = async (addressId, builingId) => {
      // clearCart();
      // preOrderStore.clearPrepayId();
      // preOrderStore.clearIdCard();
      // const thankYouPath = { name: 'thank-you', query: { order: orderGetters.getId(order.value) } };
      // router.push(root.localePath(thankYouPath));
      try {

        const userKey = context.root?.$cookies.get("userKey");
        const tokenkey = context.root?.$cookies.get("tokenkey");
        const data = {
          // address_id: preOrderStore?.address?.addressId,
          fx_id: '0',
          from_id: tokenkey,
          member_note: orderNote.value,
          shopping_list: shoppingList(),
          combine_pay: true,
          // billing_address_id: preOrderStore?.builing?.addressId,
          is_pick_up_order: false,
          has_insurance: hasInsurance.value,
          email: email.value
        };
        if (addressId) {
          data.address_id = addressId;
        }
        if (builingId) {
          data.billing_address_id = builingId;
        }
        if (preOrderStore?.address?.country) {
          data.delivery_country = preOrderStore?.address?.country;
        }
        if (preOrderStore?.address?.state) {
          data.delivery_state = preOrderStore?.address?.state;
        }
        if (userKey) {
          data.user_id = userKey;
        }
        if (preOrderStore.shippingMethods && preorder.value && preOrderStore.shippingMethods.length === preorder.value?.orders?.length) {
          data.express = preOrderStore.shippingMethods;
        }
        if (preOrderStore?.preview_id) {
          data.preview_id = preOrderStore?.preview_id;
        }
        // 传入store的previewkey
        if (preOrderStore?.previewKey) {
          data.preview_serial_id = preOrderStore?.previewKey;
        }
        if (preOrderStore?.IdCard && preOrderStore?.IdCard?.id_number && preOrderStore?.IdCard?.id_name) {
          data.id_name = preOrderStore.IdCard.id_name;
          data.id_number = preOrderStore.IdCard.id_number;
          data.id_type = preOrderStore.IdCard.id_type;
        } else if (preOrderStore?.IdCard?.id_type || preOrderStore?.IdCard?.id_number || preOrderStore?.IdCard?.id_name) {
          // return false;
        }
        await create(data);
        await createSuccess();
      } catch (e) {
        createLodding.value = false;
        console.log(e);
        return e;
      }
      // const pay = { name: 'xpay', query: { orderNumber: preorder.value.orderId } };
      // router.push(root.localePath(pay));
    };
    const newCreateOrder = (addressId, billignId) => {
      if (isShowEmail.value) {
        if (email.value && !validateEmail(email.value)) {
          setError({ message: context.root.$t('emailError'), code: 500 });
          return new Promise((resolve, reject) => {
            reject(false);
          });
        } else if (!email.value || email.value === '') {
          setError({ message: context.root.$t('emailNotNullError'), code: 500 });
          return new Promise((resolve, reject) => {
            reject(false);
          });
        }
      }
      if (!payWayId.value) {
        setError({ message: context.root.$t('paymentMethodNotNull'), code: 500 });
        return new Promise((resolve, reject) => {
          reject(false);
        });
      }
      return preOrderAdd(addressId, billignId).then(() => {
        if (!((preOrderErr.value && preOrderErr.value.load !== null) || (preorder.value && preorder.value.errs && preorder.value.errs.length !== 0))) {
          if (createLodding.value) {
            return false;
          }
          createLodding.value = true;
          return processOrder(addressId, billignId);
        }
      }).catch(() => {
        createLodding.value = false;
        return false;
      });
    };
    const createOrderFc = () => {
      EventBus.$emit('show-notification', {
        type: 'loading',
        message: context.root.$t('orderCreateLoading'),
        duration: 10000,
        closable: true
      });
      const IdValid = IdCardRef.value?.checkedValid();
      if (preorder?.value?.hasIdentityCheck && !IdValid) {
        EventBus.$emit('close-notification', Id);
        createLodding.value = false;
        setError({ message: context.root.$t('IdCardNotNull'), code: 500 });
        return false;
      } else {
        const card = IdCardRef.value?.getIdCard();
        try {
          if (card && card.idNumber && card.idName) {
            preOrderStore.setIdName(card.idName);
            preOrderStore.setIdNumber(card.idNumber);
            preOrderStore.setIdType(card.idType);
          }
        } catch (e) {
          console.log(e);
        }
      }
      // EventBus.$emit('close-notification', id);
      if (addressIdRef.value && addressIdRef.value !== '-1') {
        if (billingAndShipping.value) {
          preOrderStore.copyAddress();
          newCreateOrder(addressIdRef.value, addressIdRef.value).then((res) => {
            EventBus.$emit('close-notification', Id);
          }).catch(() => {
            EventBus.$emit('close-notification', Id);
            createLodding.value = false;
          });
        } else if (billingIdRef.value && billingIdRef.value !== '-1') {
          newCreateOrder(addressIdRef.value, billingIdRef.value).then(() => {
            EventBus.$emit('close-notification', Id);
            createLodding.value = false;
          }).catch(() => {
            EventBus.$emit('close-notification', Id);
            createLodding.value = false;
          });
        } else {
          billingForm.value.handleFormSubmit().then(async (builingRes) => {
            if (builingRes && builingRes.addressId) {
              newCreateOrder(addressIdRef.value, builingRes.addressId).then(() => {
                EventBus.$emit('close-notification', Id);
                createLodding.value = false;
              }).catch(() => {
                EventBus.$emit('close-notification', Id);
                createLodding.value = false;
              });
            } else {
              setError({ message: context.root.$t('BillingInfoNotNull'), code: 500 });
              EventBus.$emit('close-notification', Id);
              createLodding.value = false;
            }
          });
        }
      } else {
        addressForm.value.handleFormSubmit().then(async (result) => {
          try {
            if (result && result.addressId) {
              if (billingAndShipping.value) {
                preOrderStore.copyAddress();
                newCreateOrder(result.addressId, result.addressId).then((res) => {
                  EventBus.$emit('close-notification', Id);
                }).catch(() => {
                  EventBus.$emit('close-notification', Id);
                  createLodding.value = false;
                });
              } else if (billingIdRef.value && billingIdRef.value !== '-1') {
                newCreateOrder(result.addressId, billingIdRef.value).then(() => {
                  EventBus.$emit('close-notification', Id);
                  createLodding.value = false;
                }).catch(() => {
                  EventBus.$emit('close-notification', Id);
                  createLodding.value = false;
                });
              } else {
                billingForm.value.handleFormSubmit().then(async (builingRes) => {
                  if (builingRes && builingRes.addressId) {
                    newCreateOrder(result.addressId, builingRes.addressId).then(() => {
                      EventBus.$emit('close-notification', Id);
                      createLodding.value = false;
                    }).catch(() => {
                      EventBus.$emit('close-notification', Id);
                      createLodding.value = false;
                    });
                  } else {
                    setError({ message: context.root.$t('BillingInfoNotNull'), code: 500 });
                    EventBus.$emit('close-notification', Id);
                    createLodding.value = false;
                  }
                }).catch(() => {
                  EventBus.$emit('close-notification', Id);
                  createLodding.value = false;
                });
              }
            } else {
            // console.log('Form is invalid!');
              setError({ message: context.root.$t('shippingInfoNotNull'), code: 500 });
              EventBus.$emit('close-notification', Id);
              createLodding.value = false;
            }
          } catch (e) {
            EventBus.$emit('close-notification', Id);
            createLodding.value = false;
          }
        }).catch(() => {
        // console.log('Form is invalid!');
          EventBus.$emit('close-notification', Id);
          createLodding.value = false;
        });
      }

    };
    // 支付方式
    const changePayWay = (method) => {
      const orderCurrency = preorder?.value?.transCurrency;
      preOrderStore.setPaymethod(method);
      if (method.currencies && method.currencies.length) {
        if (method.currencies.includes(orderCurrency)) {
          currency.value = orderCurrency;
        } else {
          currency.value = method.currencies?.[0];
        }
      } else {
        currency.value = '';
      }
    };
    const closeWechatPayCodeModal = () => {
      goXpay();
    };
    // 选择收货地址组件回调
    const backAddress = async (address) => {
      if (address) {
        // selectAddress(address, 1);
        addressIdRef.value = address.addressId;
        if (address.value !== '-1') {
          await preOrderStore.setAddress(address);
        } else {
          await preOrderStore.clearAddress();
        }
        EventBus.$emit('NewPreviewOrder', address);
      } else {
        addressIdRef.value = '-1';
        preOrderStore.clearAddress();
      }
    };
    const backBuiling = (builing) => {
      if (builing) {
        // selectAddress(builing, 2);
        billingIdRef.value = builing.addressId;
        if (builing.value !== '-1') {
          preOrderStore.setBuiling(builing);
        } else {
          preOrderStore.clearBuiling();
        }
        EventBus.$emit('NewPreviewOrder', builing);
      } else {
        billingIdRef.value = '-1';
        preOrderStore.clearBuiling();
      }
    };
    return {
      billingAndShipping,
      billingAddressChange,
      address,
      preorder,
      preOrderErr,
      isShowEmail,
      email,
      OrderEmailChange,
      OrderNoteChange,
      orderNote,
      createLodding,
      preOrderLoading,
      builing,
      isMobile,
      createOrderFc,
      addressForm,
      billingForm,
      payMethods,
      payWayId,
      currency,
      changePayWay,
      observers,
      wechatPayCodeModal,
      closeWechatPayCodeModal,
      wechatPayCodeImg,
      payCodeVisable,
      backProvider,
      backAddress,
      addressIdRef,
      backBuiling,
      billingIdRef,
      IdCardRef
    };
  },
  components: {
    newCartPreview,
    ShippingAddressSelect,
    SfHeading,
    SfInput,
    SfButton,
    SfSelect,
    SfLink,
    SfAddressPicker,
    SfModal,
    SfCharacteristic,
    SfCheckbox,
    SfImage,
    SfProperty,
    SfAccordion,
    SfList,
    SfTextarea,
    SfQuantitySelector,
    SfCircleIcon,
    SfDivider,
    shippingForm,
    SfIcon,
    SfRadio,
    ValidationProvider,
    ValidationObserver,
    confirmModal,
    shippingSelect,
    IdCard
  }
};
